import { render, staticRenderFns } from "./FaturadosDiaDia.vue?vue&type=template&id=2478ab5c&scoped=true"
import script from "./FaturadosDiaDia.vue?vue&type=script&lang=js"
export * from "./FaturadosDiaDia.vue?vue&type=script&lang=js"
import style0 from "./FaturadosDiaDia.vue?vue&type=style&index=0&id=2478ab5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478ab5c",
  null
  
)

export default component.exports